// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.customText .MuiInputLabel-outlined.MuiInputLabel-shrink {
  display: none;
}
.customText .MuiOutlinedInput-root {
  width: 100%;
  height: 32px;
  font-size: 13px;
}
input[type="text"]::-webkit-input-placeholder {
  font-size: 13px;
  color: #000;
}
.customText .MuiFormControl-root {
  width: 100%;
}
.customText .MuiOutlinedInput-notchedOutline {
  border-color: #ececec;
}
.customText.customTextError .MuiOutlinedInput-notchedOutline {
  border-color: red;
}
.loginField .MuiInputLabel-outlined.MuiInputLabel-shrink {
  display: none;
}
.loginField .MuiOutlinedInput-root {
  width: 100%;
  height: 50px;
  border-radius: 30px !important;
  background: #F7F7F7;
}
.loginField .MuiFormControl-root {
  width: 100%;
}
.loginField .MuiOutlinedInput-notchedOutline {
  border-color: #ececec;
}
.loginField.customTextError .MuiOutlinedInput-notchedOutline {
  border-color: red;
}
`, "",{"version":3,"sources":["webpack://./src/styles/custom-text.css"],"names":[],"mappings":"AAAA;EACE,aAAa;AACf;AACA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;AACA;EACE,eAAe;EACf,WAAW;AACb;AACA;EACE,WAAW;AACb;AACA;EACE,qBAAqB;AACvB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,aAAa;AACf;AACA;EACE,WAAW;EACX,YAAY;EACZ,8BAA8B;EAC9B,mBAAmB;AACrB;AACA;EACE,WAAW;AACb;AACA;EACE,qBAAqB;AACvB;AACA;EACE,iBAAiB;AACnB","sourcesContent":[".customText .MuiInputLabel-outlined.MuiInputLabel-shrink {\r\n  display: none;\r\n}\r\n.customText .MuiOutlinedInput-root {\r\n  width: 100%;\r\n  height: 32px;\r\n  font-size: 13px;\r\n}\r\ninput[type=\"text\"]::-webkit-input-placeholder {\r\n  font-size: 13px;\r\n  color: #000;\r\n}\r\n.customText .MuiFormControl-root {\r\n  width: 100%;\r\n}\r\n.customText .MuiOutlinedInput-notchedOutline {\r\n  border-color: #ececec;\r\n}\r\n.customText.customTextError .MuiOutlinedInput-notchedOutline {\r\n  border-color: red;\r\n}\r\n.loginField .MuiInputLabel-outlined.MuiInputLabel-shrink {\r\n  display: none;\r\n}\r\n.loginField .MuiOutlinedInput-root {\r\n  width: 100%;\r\n  height: 50px;\r\n  border-radius: 30px !important;\r\n  background: #F7F7F7;\r\n}\r\n.loginField .MuiFormControl-root {\r\n  width: 100%;\r\n}\r\n.loginField .MuiOutlinedInput-notchedOutline {\r\n  border-color: #ececec;\r\n}\r\n.loginField.customTextError .MuiOutlinedInput-notchedOutline {\r\n  border-color: red;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
